import OrderForwardEditRequest from "../../api/raily/order-forward/edit/order-forward-edit.request";
import orderForwardApiService from "../../api/raily/order-forward/order-forward-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import httpHelper from "../../utils/http/http.helper";
import OrderForwardEditError from "./edit/order-forward-edit-error";
import OrderForwardEditParams from "./edit/order-forward-edit-params";
import orderForwardEditParamsFactory from "./edit/order-forward-edit-params.factory";
import OrderForwardList from "./list/order-forward-list";
import OrderForwardListError from "./list/order-forward-list-error";
import OrderForwardListParams from "./list/order-forward-list-params";
import orderForwardListParamsFactory from "./list/order-forward-list-params.factory";
import orderForwardListFactory from "./list/order-forward-list.factory";

const getList = async (
  params: OrderForwardListParams,
  abortSignal: AbortSignal,
): Promise<OrderForwardList> => {
  const request = orderForwardListParamsFactory.create(params);

  try {
    const response = await orderForwardApiService().getList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderForwardListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | OrderForwardListError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const editForwarding = async (
  params: OrderForwardEditParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderForwardEditRequest =
    orderForwardEditParamsFactory.create(params);

  try {
    const response = await orderForwardApiService().editForwarding(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderForwardEditError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const orderForwardService = {
  getList,
  editForwarding,
};

export default orderForwardService;
